import { render, staticRenderFns } from "./Notificador.vue?vue&type=template&id=4917332e&scoped=true"
import script from "./Notificador.vue?vue&type=script&lang=js"
export * from "./Notificador.vue?vue&type=script&lang=js"
import style0 from "./Notificador.vue?vue&type=style&index=0&id=4917332e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4917332e",
  null
  
)

export default component.exports